import { Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API, API_ROUTES } from '@app/shared/utils/api-routes';
import { environment } from '@environments/environment';
import { createHttpParams } from '@app/shared/utils/utils';
import { AlertLog } from '@app/shared/interfaces/alert-log.interface';

@Injectable({
  providedIn: 'root',
})
export class AlertLogService {
  constructor(private httpClient: HttpClient) {}

  public getAlertsLog(params: { [key: string]: string }): Observable<{ Items: AlertLog[] }> {
    return this.httpClient
      .get(`${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.ALERTS}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        params: createHttpParams(params),
      })
      .pipe(map((res) => res)) as Observable<{ Items: AlertLog[] }>;
  }

  public putAlertsLog(alerts: Partial<AlertLog>): Observable<{ Items: AlertLog }> {
    const { timestamp: id, ...rest } = alerts;
    return this.httpClient
      .put(
        `${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.ALERTS}/${id}`,
        { ...rest },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      .pipe(map((res) => res)) as Observable<{ Items: AlertLog }>;
  }
}
